module.exports = __webpack_public_path__ + "img/Download-submissionguidelines.4b50ece2.svg";